import React, { useState } from "react";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";

const CompanyInfoModal = ({ companyInfoModal, setCompanyInfoModal }) => {
	const [allCheck, setAllCheck] = useState(false);
	const [inquiryFinalList, setInquiryFinalList] = useState([
		{ type: "TITLE", title: "", content: "", order: 0, selectOption: [], required: false },
	]);
	const [orderNum, setOrderNum] = useState(1);
	const [inquiryDefaultInfo, setInquiryDefaultInfo] = useState({
		companyName: false, //기업명
		businessNumber: false, //사업자등록번호,
		ceo: false, // 대표
		sales: false, // 매출
		industry: false, // 산업분야
		differentiation: false, // 차별성
		establishment: false, // 설립일자
		employee: false, // 직원수
		companyType: false, // 기업구분
		nation: false, // 국가
		stocks: false, // 상장구분
		keywords: false, // 키워드
		address: false, // 주소
		homepage: false, // 홈페이지
		description: false, // 기업개요
		productName: false, // 제품명
		productDescription: false, // 제품한줄소개
	});

	function defaultAdd(temp, type = "SHORT", title, content, orderNum) {
		return [
			...temp,
			{
				type: type,
				order: orderNum,
				selectOption: [],
				title: title,
				content: content,
				required: false,
			},
		];
	}

	const defaultModalSubmit = () => {
		let temp = [...inquiryFinalList];
		let order = orderNum;
		let i = 0;
		if (inquiryDefaultInfo.companyName)
			temp = defaultAdd(temp, "SHORT", "기업명", "name", order + i++);
		if (inquiryDefaultInfo.establishment)
			temp = defaultAdd(temp, "DATE", "설립일자", "estDate", order + i++);
		if (inquiryDefaultInfo.address) temp = defaultAdd(temp, "ADDRESS", "주소", "address", order + i++);
		if (inquiryDefaultInfo.businessNumber)
			temp = defaultAdd(temp, "SHORT", "사업자등록번호", "regNum", order + i++);
		if (inquiryDefaultInfo.employee)
			temp = defaultAdd(temp, "SHORT", "직원수", "employeeNum", order + i++);
		if (inquiryDefaultInfo.homepage)
			temp = defaultAdd(temp, "SHORT", "홈페이지", "homepage", order + i++);
		if (inquiryDefaultInfo.ceo) temp = defaultAdd(temp, "SHORT", "대표", "ceoName", order + i++);
		if (inquiryDefaultInfo.companyType)
			temp = [
				...temp,
				{
					type: "CHOICE",
					title: "기업구분",
					content: "type",
					order: order + i++,
					required: false,
					selectOption: [{ title: "예비 창업" }, { title: "법인 사업자" }, { title: "개인 사업자" }],
				},
			];
		if (inquiryDefaultInfo.description)
			temp = defaultAdd(temp, "LONG", "기업개요", "introduction", order + i++);
		if (inquiryDefaultInfo.sales) temp = defaultAdd(temp, "SHORT", "매출", "", order + i++);
		if (inquiryDefaultInfo.nation) temp = defaultAdd(temp, "SHORT", "국가", "country", order + i++);
		if (inquiryDefaultInfo.productName)
			temp = defaultAdd(temp, "SHORT", "제품", "", order + i++);
		if (inquiryDefaultInfo.industry)
			temp = defaultAdd(temp, "SHORT", "산업분야", "fields", order + i++);
		if (inquiryDefaultInfo.stocks)
			temp = [
				...temp,
				{
					type: "ALTERNATIVE",
					title: "상장구분",
					content: "listed",
					order: order + i++,
					required: false,
					selectOption: [{ title: "상장" }, { title: "비상장" }],
				},
			];
		if (inquiryDefaultInfo.productDescription)
			temp = defaultAdd(temp, "LONG", "제품 한 줄 소개", "", order + i++);
		if (inquiryDefaultInfo.differentiation)
			temp = defaultAdd(temp, "LONG", "차별성", "", order + i++);
		if (inquiryDefaultInfo.keywords) temp = defaultAdd(temp, "TAG", "키워드", "", order + i++);

		setInquiryDefaultInfo({
			companyName: false, //기업명
			businessNumber: false, //사업자등록번호,
			ceo: false, // 대표
			sales: false, // 매출
			industry: false, // 산업분야
			differentiation: false, // 차별성
			establishment: false, // 설립일자
			employee: false, // 직원수
			companyType: false, // 기업구분
			nation: false, // 국가
			stocks: false, // 상장구분
			keywords: false, // 키워드
			address: false, // 주소
			homepage: false, // 홈페이지
			description: false, // 기업개요
			productName: false, // 제품명
			productDescription: false, // 제품한줄소개
		});
		setOrderNum(order + i);
		setInquiryFinalList(temp);
	};
	const handleChange = (e) => {
		let temp = { ...inquiryDefaultInfo, [e.target.name]: e.target.value === "false" };
		setInquiryDefaultInfo(temp);
	};

	const allChange = (e) => {
		setInquiryDefaultInfo({
			companyName: e.target.value === "false", //기업명
			businessNumber: e.target.value === "false", //사업자등록번호,
			ceo: e.target.value === "false", // 대표
			sales: e.target.value === "false", // 매출
			industry: e.target.value === "false", // 산업분야
			differentiation: e.target.value === "false", // 차별성
			establishment: e.target.value === "false", // 설립일자
			employee: e.target.value === "false", // 직원수
			companyType: e.target.value === "false", // 기업구분
			nation: e.target.value === "false", // 국가
			stocks: e.target.value === "false", // 상장구분
			keywords: e.target.value === "false", // 키워드
			address: e.target.value === "false", // 주소
			homepage: e.target.value === "false", // 홈페이지
			description: e.target.value === "false", // 기업개요
			productName: e.target.value === "false", // 제품명
			productDescription: e.target.value === "false", // 제품한줄소개
		});
		setAllCheck(e.target.value === "false");
	};
	const handleSubmit = () => {
		defaultModalSubmit();
		setCompanyInfoModal(false);
	};

	return (
		<ModalTemplate
			modalState={companyInfoModal}
			setModalToggle={setCompanyInfoModal}
			title={
				<>
					기업정보 선택<div>기업 기본 요청 폼을 바로 작성하실 수 있습니다.</div>
				</>
			}
			width={450}
			height={410}
			className="company-infoChk-modal light"
		>
			<div className="modal-content">
				<div className="checkbox">
					<label className="checkbox-custom">
						<input
							type="checkbox"
							checked={allCheck}
							value={allCheck}
							onChange={allChange}
						/>
						<span className="checkmark" />
						<span className="checkbox-label">전체</span>
					</label>
				</div>

				<div className="checkbox-group">
					<div className="group">
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"companyName"}
									value={inquiryDefaultInfo.companyName}
									checked={inquiryDefaultInfo.companyName}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">기업명</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"businessNumber"}
									value={inquiryDefaultInfo.businessNumber}
									checked={inquiryDefaultInfo.businessNumber}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">사업자등록번호</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"ceo"}
									value={inquiryDefaultInfo.ceo}
									checked={inquiryDefaultInfo.ceo}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">대표</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"sales"}
									value={inquiryDefaultInfo.sales}
									checked={inquiryDefaultInfo.sales}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">매출</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"industry"}
									value={inquiryDefaultInfo.industry}
									checked={inquiryDefaultInfo.industry}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">산업분야</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"differentiation"}
									value={inquiryDefaultInfo.differentiation}
									checked={inquiryDefaultInfo.differentiation}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">차별성</span>
							</label>
						</div>
					</div>

					<div className="group">
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"establishment"}
									value={inquiryDefaultInfo.establishment}
									checked={inquiryDefaultInfo.establishment}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">설립일자</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"employee"}
									value={inquiryDefaultInfo.employee}
									checked={inquiryDefaultInfo.employee}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">직원수</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"companyType"}
									value={inquiryDefaultInfo.companyType}
									checked={inquiryDefaultInfo.companyType}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">기업구분</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"nation"}
									value={inquiryDefaultInfo.nation}
									checked={inquiryDefaultInfo.nation}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">국가</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"stocks"}
									value={inquiryDefaultInfo.stocks}
									checked={inquiryDefaultInfo.stocks}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">상장구분</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"keywords"}
									value={inquiryDefaultInfo.keywords}
									checked={inquiryDefaultInfo.keywords}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">키워드</span>
							</label>
						</div>
					</div>

					<div className="group">
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"address"}
									value={inquiryDefaultInfo.address}
									checked={inquiryDefaultInfo.address}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">주소</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"homepage"}
									value={inquiryDefaultInfo.homepage}
									checked={inquiryDefaultInfo.homepage}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">홈페이지</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"description"}
									value={inquiryDefaultInfo.description}
									checked={inquiryDefaultInfo.description}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">기업개요</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"productName"}
									value={inquiryDefaultInfo.productName}
									checked={inquiryDefaultInfo.productName}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">제품명</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"productDescription"}
									value={inquiryDefaultInfo.productDescription}
									checked={inquiryDefaultInfo.productDescription}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">제품한줄소개</span>
							</label>
						</div>
					</div>
				</div>
			</div>
			<div className="modal-footer">
				<button type="button" className="btn__solid" color="primary" onClick={handleSubmit}>
					선택완료
				</button>
			</div>
		</ModalTemplate>
	);
};

export default React.memo(CompanyInfoModal);
